import { GradientButtonProps } from "./types";

const GradientButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  variant = "primary",
}: GradientButtonProps) => {
  const baseClass = variant === "alt" ? "bg-gradient-btn1" : "bg-gradient-btn";

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`${baseClass} hover:bg-blue-700 w-fit text-white font-[600] text-sm py-2 px-4 rounded-full focus:outline-none focus:shadow-outline transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {children}
    </button>
  );
};

export default GradientButton;
